// 「前往活動設定」的網址（#1696）：後台與 AI 管家同一個主網域，去掉第一段子網域即是後台。
// 例：chat.dev.joleehi.com → dev.joleehi.com；ai.joleehi.com → joleehi.com。協定沿用目前頁面

type PageLocation = Pick<Location, 'protocol' | 'hostname' | 'host'>

// 🔴 後台路由由使用者提供，repo 內沒有其他引用；前端改路由時要同步這裡
const ACTIVITY_SETTING_PATH = '/admin/activity/list/setting/'

const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/

/** 後台的 origin。localhost、IP 或本身就是主網域時沒有子網域可去，照原樣並保留 port */
export const adminOrigin = ({ protocol, hostname, host }: PageLocation): string => {
  const labels = hostname.split('.')
  const target = !IPV4.test(hostname) && labels.length > 2 ? labels.slice(1).join('.') : host
  return `${protocol}//${target}`
}

/** 後台這場活動的設定頁 */
export const activitySettingUrl = (location: PageLocation, activityId: string): string =>
  `${adminOrigin(location)}${ACTIVITY_SETTING_PATH}${encodeURIComponent(activityId)}`
